import './index.scss';
import Collapse from 'bootstrap/js/dist/collapse';

import {shmAutocomplete} from 'modules/shmAutocomplete';
import {shmSearch} from './shmSearch';

shmAutocomplete.init('input.search-input');
shmSearch.init();
